import { useEffect } from 'react';

interface UseRecordHistoryEffects {
  fetchRecordHistory: () => Promise<void>;
}

export const useRecordHistoryEffects = ({
  fetchRecordHistory,
}: UseRecordHistoryEffects) => {
  useEffect(() => {
    fetchRecordHistory();
  }, [fetchRecordHistory]);
};
